export default __webpack_public_path__ + "static/media/home-garage (1).29f9843a.svg";